export const WhiteList = [
  33916017,
  53605227,
  59358349,
  60412797,
  68336744,
  50765,
  35867827,
  1112,
  6583,
  89608679,
  88727786,
  83475874,
  48674596,
  61130657,
  63599298 
]



export const GroupGrayList = []


// WEBPACK FOOTER //
// ./src/utils/white_list.js